<template>
  <el-dialog v-el-drag-dialog :close-on-click-modal="false" :visible.sync="innerVisible" :title="$t('CargoMsg.Cargo_SelectBusinessDateRange')" width="500px" @close="cancel">
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form label-width="90px" label-position="left" @submit.native.prevent>
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('CargoMsg.Cargo_AuditDate')">
            <el-date-picker
              v-model="formData.verifyDate"
              type="date"
              value-format="yyyy-MM-dd"
              style="width:251px;"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_BusinessDate')">
            <el-date-picker
              v-model="formData.businessDate"
              type="daterange"
              value-format="yyyy-MM-dd"
              style="width:251px;"
              :clearable="false"
              :editable="false"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Department')">
            <cargo-advance-select
              filterable
              :select-type="selectTypeNames.basic_data_Department"
              :method-params="{officeUuid:$store.getters.currentOfficeUuid}"
              :default-value="formData.departmentId"
              options-width="100px"
              style="width:251px;"
              @parentCallBack="($event)=>formData.departmentId=$event.value"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ItemNo')">
            <el-input v-model="formData.poNo" style="width:251px;" />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="primary" size="mini" @click="confirm">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button size="mini" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES as selectTypeNames } from '@/utils/class/AdvanceSelect'
import { Assert } from '@/utils/validate'
import DateUtils from '@/utils/dateUtils'
// import moment from 'moment'

export default {
  name: 'LockOrderDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      selectTypeNames,
      innerVisible: this.visible,
      formData: {
        verifyDate: DateUtils.customFormat(new Date(), 'YYYY-MM-DD'),
        poNo: '',
        departmentId: '',
        businessDate: []
      }
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    async confirm() {
      await Assert.isNotBlank(this.formData.verifyDate, this.$t('CargoMsg.Cargo_PleaseSelectReviewDate'), 'warning')
      // await Assert.isNotBlank(this.formData.departmentId, '请选择部门')
      await Assert.isTrue(this.formData.businessDate.length === 2, this.$t('CargoMsg.Cargo_SelectBusinessDateRange'), 'warning')
      const bizStart = this.formData.businessDate[0] + ' 00:00:00'
      const bizEnd = this.formData.businessDate[1] + ' 23:59:59'
      const verifyDate = this.formData.verifyDate
      const departmentId = this.formData.departmentId || 0
      const soNo = this.formData.poNo
      this.$emit('confirm', { accountingDate: verifyDate, soNo, departmentId, bizStart, bizEnd })
    }
  }
}
</script>

<style lang="scss">
</style>
